import React from "react";
import { useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import * as Yup from 'yup';
import { Formik } from 'formik';
import { updateBalance } from "../../reducers/users";

const BalanceModal = (props) => {
  const dispatch = useDispatch();

  const modalClose = () => {
    props.closeModal(false);
  }

  // Get tomorrow's date as minimum for scheduling
  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split('T')[0];
  };

  // Schema for yup
  const validationSchema = Yup.object().shape({
    balance: Yup.string()
      .required("*Balance is required"),
    terms: Yup.boolean()
        .oneOf([true], "You must check that you understand")
  });

  return (
    <Modal show={props.show} onHide={modalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Update Balance<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Formik
        initialValues={{balance: props.initialBalance, terms: false, sendEmail: true, userId: props.userId, scheduleBalance: false, activationDate: getTomorrowDate() }}
        validationSchema={validationSchema}
        onSubmit={(values, {setSubmitting, resetForm}) => {
            console.log("VALUES", values);
            // If scheduling is enabled, include the activation date
            const submitValues = { ...values };
            if (!values.scheduleBalance) {
              delete submitValues.activationDate;
            }
            dispatch(updateBalance(submitValues));
            props.closeModal(false);
        }}
        >
        {/* Callback function containing Formik state and helpers that handle common form actions */}
          {( {values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting }) => (
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(e)}}>
              <Form.Group className="mb-3" controlId="balance">
                <Form.Label>Balance</Form.Label>
                <Form.Control
                  name="balance"
                  type="text"
                  placeholder="New Balance"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.balance}
                  className={touched.balance && errors.balance ? "error" : null}
                />
                {touched.balance && errors.balance ? (
                  <div className="error-message">{errors.balance}</div>
                ): null}
              </Form.Group>

              <Form.Group className="mb-3" controlId="scheduleBalance">
                <Form.Check
                  name="scheduleBalance"
                  type="checkbox"
                  label="Schedule for a future date"
                  onChange={e => setFieldValue('scheduleBalance', e.target.checked)}
                  onBlur={handleBlur}
                  checked={values.scheduleBalance}
                />
              </Form.Group>

              {values.scheduleBalance && (
                <Form.Group className="mb-3" controlId="activationDate">
                  <Form.Label>Activation Date</Form.Label>
                  <Form.Control
                    name="activationDate"
                    type="date"
                    min={getTomorrowDate()}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.activationDate}
                  />
                  <Form.Text className="text-muted">
                    Funds will be added at 12:00 AM on this date.
                  </Form.Text>
                </Form.Group>
              )}

              <Form.Group className="mb-3" controlId="terms">
                <Form.Check
                  name="terms"
                  type="checkbox"
                  label="I understand that this action will add or remove funds from the user's account."
                  onChange={e => setFieldValue('terms', e.target.checked)}
                  onBlur={handleBlur}
                  checked={values.terms}
                  className={touched.terms && errors.terms ? "error" : null}
                />
                {touched.terms && errors.terms ? (
                  <div className="error-message">{errors.terms}</div>
                ): null}
              </Form.Group>

              <Form.Group className="mb-3" controlId="sendEmail">
                <Form.Check
                  name="sendEmail"
                  type="checkbox"
                  label="Send email notification to user about balance change"
                  onChange={e => setFieldValue('sendEmail', e.target.checked)}
                  onBlur={handleBlur}
                  checked={values.sendEmail}
                />
              </Form.Group>

              <Modal.Footer>
                <Button variant="secondary" onClick={modalClose}>
                  Cancel
                </Button>
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                  {values.scheduleBalance ? 'Schedule Balance' : 'Update Balance'}
                </Button>
              </Modal.Footer>
            </Form>
      )}
    </Formik>
    </Modal.Body>
    </Modal>
  );
};

export default BalanceModal;